import React, { useState } from 'react';
import "../loginSectionComponent.scss";
import { Button } from "@mui/material";
import { useDispatch } from "react-redux";
import { UseRegistration } from '../../../api/useAuth';
import {setUserValue} from "../../../reducers/userReducer";
import { useTranslation } from "react-i18next";

interface RegistrationSectionProps {
    handleRegistration: (status: boolean) => void;
    handleCloseModal: () => void;
    redirectToLogin: () => void;
}

const RegistrationSectionComponent = (props: RegistrationSectionProps) => {
    const { t } = useTranslation();
    
    const dispatch = useDispatch();
    const [name, setName] = useState<string>("");
    const [email, setEmail] = useState<string>("");
    const [phone, setPhone] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [confirmationPassword, setConfirmationPassword] = useState<string>("");
    const [authStatus, setAuthStatus] = useState<boolean>(false);

    const handleButtonFormSubmit = async () => {
        if (name && email && phone && password && confirmationPassword) {
            if (password !== confirmationPassword) {
                alert(t('auth.passwordDoNotMatch'));
                return;
            } else {
                try {
                    UseRegistration({ name, email, phone, password }).then((response: any) => {
                        if (response && response.status === 201) {
                            dispatch(setUserValue({ key: "id", value: response.result.user._id }));
                            dispatch(setUserValue({ key: "name", value: response.result.user.name }));
                            dispatch(setUserValue({ key: "email", value: response.result.user.email }));
                            dispatch(setUserValue({ key: "phoneNr", value: response.result.user.phoneNr }));
                            dispatch(setUserValue({ key: "isAuth", value: true }));
                            props.handleRegistration(true);
                            props.handleCloseModal();
                        }
                        else {
                            dispatch(setUserValue({ key: "id", value: "" }));
                            dispatch(setUserValue({ key: "name", value: "" }));
                            dispatch(setUserValue({ key: "email", value: "" }));
                            dispatch(setUserValue({ key: "phoneNr", value: "" }));
                            dispatch(setUserValue({ key: "isAuth", value: false }));
                            props.handleRegistration(false);
                        }
                        dispatch(setUserValue({ key: "cartCount", value: 0 }));
                        dispatch(setUserValue({ key: "qrCodeCount", value: 0 }));
                    })

                } catch (e) {
                    console.log("error e: ", e);
                }
            }
        } else {
            alert(t('auth.fillAllFields'));
        }
    }

    return (
        <div className="registrationSectionComponent__container">
            <div className="registrationSectionComponent__container_content">
                <div
                    className="registrationSectionComponent__container_content-back-button-wrap"
                    onClick={props.handleCloseModal}
                >
                    <img
                        className="registrationSectionComponent__container_content-back-button"
                        src={process.env.PUBLIC_URL + '/images/close-login.svg'}
                        alt="Back to main btn"
                    />
                </div>
                <form className="registrationSectionComponent__container_content_form">
                    <div className="registrationSectionComponent__container_content_form_input_wrap name">
                        <label htmlFor="name">{t('auth.name')}</label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </div>

                    <div className="registrationSectionComponent__container_content_form_input_wrap email">
                        <label htmlFor="email">{t('auth.email')}*</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>

                    <div className="registrationSectionComponent__container_content_form_input_wrap phone">
                        <label htmlFor="phone">{t('auth.phoneNr')}*</label>
                        <input
                            type="tel"
                            id="phone"
                            name="phone"
                            required
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                        />
                    </div>

                    <div className="registrationSectionComponent__container_content_form_input_wrap password">
                        <label htmlFor="password">{t('auth.password')}*</label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>

                    <div className="registrationSectionComponent__container_content_form_input_wrap confirmation-password">
                        <label htmlFor="confirmation-password">{t('auth.confirmPassword')}*</label>
                        <input
                            type="password"
                            id="confirmation-password"
                            name="confirmation-password"
                            required
                            value={confirmationPassword}
                            onChange={(e) => setConfirmationPassword(e.target.value)}
                        />
                    </div>

                </form>

                <div className="registrationSectionComponent__container-button-btn_wrap">
                    <Button
                        className="registrationSectionComponent__container-button-btn registration"
                        variant="contained"
                        onClick={handleButtonFormSubmit}
                    >
                        <span>{t('auth.createAnAccount')}</span>
                    </Button>
                </div>

                <div className="registrationSectionComponent__container-button-alternative-wrap">
                    <div className="registrationSectionComponent__container-button-alternative">
                        <div className="registrationSectionComponent__container-button-alternative-title">
                            <span>{t('auth.orRegistrationVia')}</span>
                        </div>
                        <div className="registrationSectionComponent__container-button-alternative-btn">
                            <img src={process.env.PUBLIC_URL + '/images/google-login-icon.png'} alt="Google"/>
                            <img src={process.env.PUBLIC_URL + '/images/apple-login-icon.png'} alt="Apple"/>
                        </div>
                    </div>
                    <div className="registrationSectionComponent__container-button-redirect-to-registration-wrap">
                        <span>{t('auth.haveAccount')} <span className="registrationSectionComponent__container-button-redirect-to-registration-link" onClick={props.redirectToLogin}>{t('auth.logIn')}</span></span>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default RegistrationSectionComponent;